/**
 * Returns the browser's `navigator.userAgent` string for inclusion in
 * instrumentation events.
 *
 * Falls back to an empty string in environments where `navigator` is not
 * available (e.g., Node.js SSR, service workers) so that callers never need
 * to guard against undefined.
  * @notInstrumented
 */
export const getUserAgent = (): string => {
  try {
    // eslint-disable-next-line no-restricted-globals
    return navigator.userAgent;
  } catch {
    return '';
  }
};
